import { render, staticRenderFns } from "./facultys.vue?vue&type=template&id=4812d694&scoped=true"
import script from "./facultys.vue?vue&type=script&lang=js"
export * from "./facultys.vue?vue&type=script&lang=js"
import style0 from "./facultys.vue?vue&type=style&index=0&id=4812d694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812d694",
  null
  
)

export default component.exports